import React, { useEffect, useState } from 'react'
import ProductSec from '../Components/Productdetail/ProductSec'
import Ratings from '../Components/Productdetail/Ratings'
import Customerfeedback from '../Components/Productdetail/Customerfeedback'
import { useLocation } from 'react-router-dom'
import Header from '../Components/Header/Header'

const Praductdetail = () => {
  const [cartRefresh, setCartRefresh] = useState(false);

  const refreshCart = () => {
    setCartRefresh((prev) => !prev); // Toggle the state to trigger refresh
  };


  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [routePath]);



  return (
    <div>
      <Header cartRefresh={cartRefresh} />
      <ProductSec onCartUpdate={refreshCart}/>
      {/* <Ratings /> */}
      {/* <Customerfeedback/> */}
    </div>
  )
}

export default Praductdetail